const SECTION_SELECTOR = '[data-scroll-slider]';
const READY_KEY = 'scrollSliderReady';

function initSection( section ) {
	if ( section.dataset[ READY_KEY ] ) {
		return;
	}
	section.dataset[ READY_KEY ] = 'true';

	const track = section.querySelector( '[data-scroll-track]' );
	const prev = section.querySelector( '[data-scroll-prev]' );
	const next = section.querySelector( '[data-scroll-next]' );
	const dots = section.querySelector( '[data-scroll-dots]' );
	let stops = [];

	if ( ! track ) {
		return;
	}

	const step = () => {
		const item = track.firstElementChild;
		const gap = parseFloat( getComputedStyle( track ).columnGap ) || 0;
		return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
	};

	// Opt-in: mark the item nearest the track's start edge as `is-active`.
	const markActive = () => {
		const start = track.getBoundingClientRect().left;
		let active = null;
		let distance = Infinity;
		[ ...track.children ].forEach( ( item ) => {
			const d = Math.abs( item.getBoundingClientRect().left - start );
			if ( d < distance ) {
				distance = d;
				active = item;
			}
		} );
		[ ...track.children ].forEach( ( item ) => item.classList.toggle( 'is-active', item === active ) );
	};

	// Opt-in: one dot per item the track can scroll to the start edge.
	const buildDots = () => {
		const first = track.firstElementChild;
		const max = track.scrollWidth - track.clientWidth;
		stops = [ ...track.children ]
			.map( ( item ) => item.offsetLeft - first.offsetLeft )
			.filter( ( offset, i ) => i === 0 || offset - 1 <= max )
			.map( ( offset ) => Math.min( offset, max ) );
		dots.replaceChildren(
			...stops.map( ( offset, i ) => {
				const dot = document.createElement( 'button' );
				dot.type = 'button';
				dot.setAttribute( 'aria-label', `${ i + 1 } / ${ stops.length }` );
				dot.addEventListener( 'click', () => track.scrollTo( { left: offset, behavior: 'smooth' } ) );
				return dot;
			} )
		);
		dots.hidden = stops.length < 2;
	};

	const markDot = () => {
		let current = 0;
		stops.forEach( ( offset, i ) => {
			if ( Math.abs( track.scrollLeft - offset ) < Math.abs( track.scrollLeft - stops[ current ] ) ) {
				current = i;
			}
		} );
		[ ...dots.children ].forEach( ( dot, i ) => dot.setAttribute( 'aria-current', i === current ? 'true' : 'false' ) );
	};

	const update = () => {
		const max = track.scrollWidth - track.clientWidth - 1;
		if ( prev ) {
			prev.disabled = track.scrollLeft <= 0;
		}
		if ( next ) {
			next.disabled = track.scrollLeft >= max;
		}
		if ( track.hasAttribute( 'data-scroll-active' ) ) {
			markActive();
		}
		if ( dots ) {
			markDot();
		}
	};

	prev?.addEventListener( 'click', () => track.scrollBy( { left: -step(), behavior: 'smooth' } ) );
	next?.addEventListener( 'click', () => track.scrollBy( { left: step(), behavior: 'smooth' } ) );
	track.addEventListener( 'scroll', update, { passive: true } );
	window.addEventListener( 'resize', () => {
		if ( dots && track.firstElementChild ) {
			buildDots();
		}
		update();
	} );

	if ( dots && track.firstElementChild ) {
		buildDots();
	}
	update();
}

const ScrollSlider = {
	init( root = document ) {
		root.querySelectorAll( SECTION_SELECTOR ).forEach( initSection );
	},
};

export default ScrollSlider;
